import "./AuthLayout.scss"
import { useLocation } from "react-router-dom";
import TWButton from "../../components/utils/TWButton/TWButton"

const AuthLayout = ({ children }) => {
	const location = useLocation();
	return (
		<div className="h-full relative">
			<div className="auth__bg"></div>
			<div className="overflow-y-auto scrollbar-y absolute inset-0 py-4 h-full w-full px-4">
				<div className="pt-4 md:pt-56 pb-4 md:pb-28 mx-auto md:max-w-2xl lg:max-w-4xl">
					<div className="flex items-center justify-between md:justify-end">
						<h2 className="mr-6 text-xl 2xl:text-4xl font-bold">
							PhoriaTV
							{location.pathname === "/signup" ? "Sign Up" : "Login"}
						</h2>
						<div>
							<TWButton
								size="sm"
								to="/signup"
								color="cyan"
								className="rounded-r-none"
								outlined={location.pathname !== '/signup'}
							>
								Sign Up
							</TWButton>
							<TWButton
								size="sm"
								color="cyan"
								to="/login"
								className="rounded-l-none border-l-0"
								outlined={location.pathname !== '/login'}
							>
								Log In
							</TWButton>
						</div>
					</div>
					<div className="mt-16">
						{children}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AuthLayout